module.exports = __webpack_public_path__ + "img/circle-people-icon.6b494c74.svg";